"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react"); // useState, // useRef, // useEffect, // useCallback, // ReactNode, // Children,
const configs_1 = __importDefault(require("./configs"));
const ModalDatepicker_1 = __importDefault(require("./ModalDatepicker"));
const date_fns_1 = require("date-fns");
const InputField_1 = __importDefault(require("./InputField"));
const Modal_1 = __importDefault(require("../Modal"));
const Input = (props) => {
    const ref = (0, react_1.useRef)(null);
    const className = [
        "rounded font-heading relative appearance-none focus:outline-none transition-colors duration-300 inline-flex items-center overflow-hidden w-full px-4",
        configs_1.default?.size?.[props.size || "md"]?.text || "",
        configs_1.default?.state?.[props.isDisabled || props.isReadonly
            ? "disabled"
            : props.state || "secondary"],
        props.className || "",
    ];
    const onKeyPress = (e) => {
        // const target = e.target as HTMLInputElement;
        const allow = [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "0",
            "Backspace",
            "Delete",
        ];
        if (props.type === "decimals")
            allow.push(".");
        if (!allow.includes(e.key)) {
            e.preventDefault();
        }
    };
    const onSubmitDate = (0, react_1.useCallback)((date) => {
        if (!props.isInline)
            Modal_1.default.hide();
        if (ref.current) {
            ref.current.value = (0, date_fns_1.format)(date, "yyyy-MM-dd");
            ref.current.dispatchEvent(new Event("blur"));
            const event = ref.current;
            props.onChange && props.onChange(event);
        }
    }, [props.onChange]);
    const fnShowModalDatePicker = (0, react_1.useCallback)(() => {
        if (props.type === "date") {
            Modal_1.default.show((0, jsx_runtime_1.jsx)(ModalDatepicker_1.default, { date: props.value || props.defaultValue, withYear: props.withYear, min: props.min, max: props.max, onCancel: Modal_1.default.hide, onSubmit: onSubmitDate }), {
                close: {
                    display: false,
                },
                overlay: {
                // overrideClassName: "overflow-x-hidden",
                },
                container: {
                // className: "flex justify-end min-h-screen",
                },
                wrapper: {
                // className:
                //   "transition-all duration-300 py-5 px-5 relative bg-white w-[300px]",
                // animatedClassNames: {
                //   appear: "opacity-0 -right-full",
                //   appearActive: "opacity-0 -right-full",
                //   appearDone: "opacity-100",
                //   enter: "opacity-0 -right-full",
                //   enterActive: "opacity-0 -right-full",
                //   enterDone: "opacity-100 right-0",
                //   exit: "right-0",
                //   exitActive: "opacity-0 -right-full",
                //   exitDone: "opacity-0 -right-full",
                // },
                },
            });
        }
    }, []);
    // console.log(props.name, props.isDisabled);
    let spreadProps = {
        className: className.join(" "),
        disabled: props.isDisabled,
        required: props.isRequired,
        name: props.name,
        id: props.id,
        type: props.type,
        pattern: props.pattern,
        maxLength: props.maxLength,
        placeholder: props.placeholder,
        readOnly: props.isReadonly,
    };
    if (props.onClick) {
        spreadProps.onClick = props.onClick;
    }
    if (props.onChange) {
        spreadProps.onChange = props.onChange;
    }
    if (props.onKeyPress) {
        spreadProps.onKeyPress = props.onKeyPress;
    }
    if (props.onKeyDown) {
        spreadProps.onKeyDown = props.onKeyDown;
    }
    if (props.onBlur) {
        spreadProps.onBlur = props.onBlur;
    }
    if (["number", "decimals", "currency"].includes(props.type)) {
        spreadProps.type = "text";
        if (props.type === "decimals") {
            spreadProps.type = "number";
            spreadProps.step = 0.01;
        }
        if (props.type === "number") {
            spreadProps.type = "number";
            spreadProps.onBlur = (event) => {
                if (event.target.min && +event.target.value < +event.target.min)
                    event.target.value = event.target.min;
                if (event.target.max && +event.target.value >= +event.target.max)
                    event.target.value = event.target.max;
                if (props.onBlur)
                    props.onBlur(event);
            };
        }
        spreadProps.min = props.min;
        spreadProps.max = props.max;
        spreadProps.onKeyPress = onKeyPress;
    }
    if (["file"].includes(props.type)) {
        spreadProps.accept = props.accept;
    }
    if (["date"].includes(props.type)) {
        if (props.isInline) {
            spreadProps.className = spreadProps.className + "hidden";
            spreadProps.min = props.min;
            spreadProps.max = props.max;
        }
        // spreadProps.minDate = props.min;
        // spreadProps.maxDate = props.max;
    }
    if (!!props.defaultValue)
        spreadProps.defaultValue = props.defaultValue;
    if (!!props.value) {
        spreadProps.value = props.value;
    }
    if (!!props.defaultChecked)
        spreadProps.defaultChecked = props.defaultChecked;
    if (!!props.checked)
        spreadProps.checked = props.checked;
    return ((0, jsx_runtime_1.jsxs)("fieldset", { className: ["relative", props.wrapperClassName].join(" "), id: `fieldset-${props.id}`, children: [props.label && ((0, jsx_runtime_1.jsxs)("label", { htmlFor: props.id, className: "text-gray-900 dark:text-gray-200 flex mb-2 text-sm font-medium", children: [props.label, props.isRequired && (0, jsx_runtime_1.jsx)("span", { className: "text-red-500", children: "*" })] })), !props.isInline && props.type === "date" && ((0, jsx_runtime_1.jsx)("span", { className: "absolute inset-0 cursor-pointer", onClick: fnShowModalDatePicker })), (0, jsx_runtime_1.jsx)(InputField_1.default, { size: props.size, reference: ref, list: props.list, listWrapperClassName: props.listWrapperClassName, spreadProps: spreadProps, fnShowModalDatePicker: fnShowModalDatePicker, addOn: props.addOn, isInline: props.isInline, withYear: props.withYear, onSubmitDate: onSubmitDate })] }));
};
Input.defaultProps = {
    className: "",
    size: "md",
    state: "secondary",
    color: "link",
    autoComplete: "off",
};
exports.default = Input;
